// @flow

import { connect } from "react-redux";
import React from "react";

import Content from "./Content";

import type { AppState, ReportModalType } from "src/types";

type Props = {
  modalType: ?ReportModalType,
};

const Modal = ({ modalType }: Props) => {
  if (modalType) {
    return <Content type={modalType} />;
  }

  return <></>;
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  modalType: app.reports.modal.modalType,
});

export default connect(mapStateToProps)(Modal);
